<template>
  <div class="d-flex justify-center actions-bar">
    <NewInterviewFormatTemplateDialog @close="closeDialog" :isOpen="isOpen" />
    <SecondaryButton
      @click.native="openDialog"
      permission="create"
      color="primary"
    >
      <div class="d-flex align-center justify-center">
        <v-icon>mdi-clipboard-text-outline</v-icon>
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Interview Template
    </SecondaryButton>
  </div>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewInterviewFormatTemplateDialog from "@/views/settings/components/interview-format-templates/components/dialogs/NewInterviewFormatTemplateDialog";

export default {
  components: {
    NewInterviewFormatTemplateDialog,
    SecondaryButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
